export default function PS5() {
    return (
        <svg width="41" height="41" viewBox="0 0 41 41" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M11.1167 33.3799H9.28895C9.01187 33.3799 8.77853 33.5743 8.72506 33.8465L8.01048 37.6479C7.94242 38.0028 8.21464 38.3285 8.57437 38.3285H25.982C26.3563 38.3285 26.6334 37.9736 26.5362 37.609L25.982 35.4993"
                stroke="black"
                strokeWidth="1.25"
                stroke-miterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M11.1604 3.32861V36.1703H12.5604C14.4125 36.1703 15.8903 34.6196 15.7979 32.7675L14.5194 6.52722C14.4319 4.73834 12.9542 3.32861 11.1604 3.32861Z"
                stroke="black"
                strokeWidth="1.25"
                stroke-miterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M19.4926 34.9939C18.7488 34.3668 18.6565 33.8224 18.7051 32.7675L19.9835 6.52722C20.0759 4.73834 21.5537 3.32861 23.3426 3.32861V27.9453"
                stroke="black"
                strokeWidth="1.25"
                stroke-miterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path d="M14.6506 9.23975H19.8423" stroke="black" strokeWidth="1.25" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.6222 33.3799H15.8027" stroke="black" strokeWidth="1.25" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M15.9634 9.23975L16.0266 10.8877" stroke="black" strokeWidth="1.25" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M16.1091 13.1235L16.2307 16.4777"
                stroke="black"
                strokeWidth="1.25"
                stroke-miterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
                stroke-dasharray="1.98 1.98"
            />
            <path d="M16.2742 17.6011L16.3374 19.249" stroke="black" strokeWidth="1.25" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18.705 9.23975L18.637 10.8877" stroke="black" strokeWidth="1.25" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M18.5492 13.1235L18.418 16.4777"
                stroke="black"
                strokeWidth="1.25"
                stroke-miterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
                stroke-dasharray="1.98 1.98"
            />
            <path d="M18.3745 17.6011L18.3064 19.249" stroke="black" strokeWidth="1.25" stroke-miterlimit="10" strokeLinecap="round" strokeLinejoin="round" />
            <path
                d="M22.2341 29.8893C22.3314 29.5831 22.6182 29.374 22.939 29.374H26.9057H31.232C31.5675 29.374 31.8591 29.5976 31.9466 29.9185L33.3709 35.1685C33.648 36.1844 32.8897 37.1858 31.8348 37.2004C31.198 37.2101 30.6147 36.8358 30.3473 36.2525L29.4772 34.3324H24.2807L23.4786 36.2525C23.2355 36.8358 22.6668 37.215 22.0348 37.215C20.9751 37.215 20.2216 36.1844 20.5473 35.1782L22.2341 29.8893Z"
                stroke="black"
                strokeWidth="1.25"
                stroke-miterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29.5258 24.5181C29.5258 24.5181 30.4494 26.0736 29.273 26.5597C28.0967 27.0458 27.0515 24.1924 27.0515 26.1076V29.3743"
                stroke="black"
                strokeWidth="1.25"
                stroke-miterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M29.4724 32.7968C29.9019 32.7968 30.2501 32.4485 30.2501 32.019C30.2501 31.5894 29.9019 31.2412 29.4724 31.2412C29.0428 31.2412 28.6946 31.5894 28.6946 32.019C28.6946 32.4485 29.0428 32.7968 29.4724 32.7968Z"
                stroke="black"
                strokeWidth="1.25"
                stroke-miterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M25.2624 32.7968C25.692 32.7968 26.0402 32.4485 26.0402 32.019C26.0402 31.5894 25.692 31.2412 25.2624 31.2412C24.8328 31.2412 24.4846 31.5894 24.4846 32.019C24.4846 32.4485 24.8328 32.7968 25.2624 32.7968Z"
                stroke="black"
                strokeWidth="1.25"
                stroke-miterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
